import BlankCard from '@components/blank/BlankCard';
import BlankItem from '@components/blank/BlankItem';
import Header from '@components/Header';
import Loading from '@components/Loading';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import CardList from './components/CardList';
import NewCards from './components/NewCards';
import usePrepaidCardImages from './hooks/usePrepaidCardImages';

interface Params {
    type: 'GIFT' | 'BUY';
    giftItemId?: string;
}

const PrepaidCardImagesActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
  const { type, giftItemId } = params;
  const { images, isLoading, isBlank } = usePrepaidCardImages();
  return (
        <AppScreen>
            <Header title='새 카드 구매' />
            <NewCards type={type}/>
            {isLoading && (
                <Loading size='small' />
            )}
            {images?.map((row, index) => (
                <CardList data={row}
                          giftItemId={giftItemId}
                          type={type}
                          key={index.toString()}/>
            ))}
            {isBlank && (
                <BlankItem/>
            )}

        </AppScreen>
  );
};

export default PrepaidCardImagesActivity;
